var lib_core = require("lib-core");

var LogoToolStateMachine = require("./logoToolStateMachine.js");
var AbstractToolController = require("./../../../extensions/abstractToolController.js");

var LogoToolController = function(archLayers, dependencies, configuration) {
    AbstractToolController.call(this, archLayers, dependencies, configuration);
};
lib_core.inherit(LogoToolController, AbstractToolController);
LogoToolController.inject = AbstractToolController.inject;
LogoToolController.StateMachineClass = LogoToolStateMachine;

module.exports = LogoToolController;

LogoToolController.prototype.getButtonElements = function () {
    var buttonElements = {
        name: 'Logo',
        description: 'Logo Importer Tool',
        style: {
            icon: 'icon-text.svg',
        },
        eventData: {
            "tool": this.name()
        },
        auto_escape: true
    };

    return buttonElements;
};
